import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import mail from 'assets/images/Dashboard/mail-request.svg';
import call from 'assets/images/Dashboard/call-request.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import ReusablePagination from 'components/commom/Pagination';
import CommonToast from 'components/commom/CommonToast';
import LabelWithInput from 'components/commom/LabelWithInput';
import {
  Tooltip,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
} from '@mui/material';
import { leadCaptureDetail } from 'routes/AppUrls';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';
import {
  basicDetailsValue,
  PARTICULAR_LEAD_CAPTURE,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import moment from 'moment';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import { getLeadCaptureCallAPI } from 'store/LeadCapture/getLeadCapture/action';
import ReusableButton from 'components/commom/Button';
import CommonModal from 'components/commom/Modal';
import { downloadLeadCaptureCallAPI } from 'store/LeadCapture/downloadLeadCapture/action';
import AddIcon from 'assets/images/Dashboard/add-dashboard.svg';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteLeadCaptureCallAPI } from 'store/LeadCapture/deleteLeadCapture/action';
import CreateLead from './CreateLead';
import { getLeadCaptureDetailCallAPI } from 'store/LeadCapture/getLeadCaptureDetail/action';

const LeadCapture = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const userRole = getUserRole();
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [formData, setFormData] = useState({
    search: '',
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    download: 'csv',
  });
  const [selectedDate, setSelectedDate] = useState({
    id: 'Today',
    name: 'Today',
  });
  const [loading, setLoading] = useState(true);
  const [isModalActive, setIsModalActive] = useState(false);
  const [viewData, setViewData] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [type, setType] = useState('');
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const itemsPerPage = 10;

  const leadList = useSelector(
    (state) => state?.getLeadCaptureReducer?.users?.data
  );
  const leadLoader = useSelector(
    (state) => state?.getLeadCaptureReducer?.loading
  );
  const downloadLoader = useSelector(
    (state) => state?.downloadLeadCaptureReducer?.loading
  );
  const leadDeleteLoader = useSelector(
    (state) => state?.deleteLeadCaptureReducer?.loading
  );
  const leadDetailLoader = useSelector(
    (state) => state?.getLeadCaptureDetailReducer?.loading
  );

  const selectDateList = [
    {
      id: 'Today',
      name: 'Today',
    },
    {
      id: 'Yesterday',
      name: 'Yesterday',
    },
    {
      id: 'Last 7 Days',
      name: 'Last 7 Days',
    },
    {
      id: 'Last 15 Days',
      name: 'Last 15 Days',
    },
    {
      id: 'Last 30 Days',
      name: 'Last 30 Days',
    },
    {
      id: 'Custom',
      name: 'Custom',
    },
  ];

  const downloadData = [
    { id: 1, name: 'CSV', slug: 'csv' },
    { id: 2, name: 'XLSX', slug: 'xlsx' },
  ];

  useEffect(() => {
    getData(1, formData?.startDate, formData?.endDate);
  }, []);

  const getData = (page = 1, startDate, endDate) => {
    const body = `${formData?.search ? `?search_text=${formData?.search}` : `?page=${page}`}&start_date=${startDate}&end_date=${endDate}`;
    dispatch(
      getLeadCaptureCallAPI(body, {
        run: true,
        handleFunction: (res) => {
          setLoading(false);
          setCount(Math.ceil(res?.count / itemsPerPage));
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (e) => {
    setSelectedDate(e?.target?.value);

    switch (e?.target?.value?.id) {
      case 'Today':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Yesterday':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 7 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(6, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 15 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(14, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 30 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(29, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;
      case 'Custom':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: '',
          ['endDate']: '',
        }));
      default:
        break;
    }
  };

  const handlePageChange = async (event, value) => {
    setPage(value);
    getData(value, formData?.startDate, formData?.endDate);
  };

  const handleApply = () => {
    getData(page, formData?.startDate, formData?.endDate);
  };

  const handleDetail = (data) => {
    dispatch(basicDetailsValue(PARTICULAR_LEAD_CAPTURE, data));
    navigate(leadCaptureDetail(locale));
  };

  const downloadFile = () => {
    const body = `${formData?.search ? `?search_text=${formData?.search}` : `?page=${page}`}&start_date=${formData?.startDate}&end_date=${formData?.endDate}&is_download=1&file_format=${formData?.download}`;
    dispatch(
      downloadLeadCaptureCallAPI(body, {
        run: true,
        handleFunction: (res) => {
          const isXlsx = formData?.download === 'xlsx';
          const mimeType = isXlsx
            ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            : 'text/csv';
          const ext = isXlsx ? 'xlsx' : 'csv';
          const blob = new Blob([res], { type: mimeType });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `lead_capture_${moment().format('YYYY-MM-DD')}.${ext}`
          );
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          setIsModalActive(false);
          showToast('Download Successfully', 'success');
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const handleAction = (event, item) => {
    setAnchorEl(event.currentTarget);
    setViewData(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    dispatch(
      deleteLeadCaptureCallAPI(viewData?.id, {
        run: true,
        handleFunction: (res) => {
          setIsModalActive(false);
          showToast(res?.message, 'success');
          getData(page, formData?.startDate, formData?.endDate);
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setSelectedDate({
      id: 'Today',
      name: 'Today',
    });
    getData(page, moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'));
  };

  const handleLeadEdit = () => {
    dispatch(
      getLeadCaptureDetailCallAPI(viewData?.id, {
        run: true,
        handleFunction: () => {
          setDrawerOpen(true);
          handleClose();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            userRole === 'enterprise-admin'
              ? ''
              : locale === 'en'
                ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
                : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="d-flex justify-between">
            <h2
              className={`fc-292D32 ${userRole === 'enterprise-admin' ? 'fs-24' : 'fs-32'} family_outfit_semiBold_600 lh-4032 m-0`}
            >
              Lead Capture
            </h2>
          </div>
          {!loading && (
            <div className="flex flex-wrap gap-x-[20px]">
              <div className="mt-[17px] w-full max-w-[180px]">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  Search:
                </div>
                <div>
                  <LabelWithInput
                    // label=""
                    placeholder="Search"
                    name="search"
                    type="text"
                    marginLabelTop={'0'}
                    marginTop={'0'}
                    bgColor="white"
                    placeholdercolor="#000000"
                    value={formData?.search}
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>
              </div>
              <div className="mt-[17px] w-full max-w-[180px]">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  {'Select Date:'}
                </div>
                <div>
                  <SelectInputBorder
                    placeholder={'Select Date'}
                    name={'selectDate'}
                    value={selectedDate?.id || ''}
                    data={selectDateList}
                    onChange={(e) => handleDateChange(e)}
                    background={'#FFFFFF'}
                    colorIcon={'#292D32'}
                    placeholderColor={'#292D32'}
                  />
                </div>
              </div>
              {selectedDate?.id === 'Custom' && (
                <>
                  <div>
                    <LabelWithInput
                      label="Start Date"
                      type="date"
                      name="startDate"
                      value={formData?.startDate}
                      disabled={false}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                      marginTop={0}
                      sx={{ mt: 0 }}
                    />
                  </div>
                  <div>
                    <LabelWithInput
                      label="End Date"
                      type="date"
                      name="endDate"
                      value={formData?.endDate}
                      disabled={false}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                    />
                  </div>
                </>
              )}
              <div className="mt-[46px] w-full max-w-[180px]">
                <div
                  className="fs-16 family_outfit_medium_500 lh-16 bg-[#375241] h-[47px] flex items-center justify-center text-white cursor-pointer w-full"
                  onClick={() => {
                    handleApply();
                  }}
                >
                  Apply
                </div>
              </div>
              <div className="mt-[46px] w-full max-w-[180px]">
                <div
                  className="fs-16 family_outfit_medium_500 lh-16 bg-[#375241] h-[47px] flex items-center justify-center text-white cursor-pointer w-full"
                  onClick={() => {
                    setIsModalActive(true);
                    setType('download');
                  }}
                >
                  Download
                </div>
              </div>
              {userRole === 'enterprise-admin' && (
                <div className="mt-[46px] w-full max-w-[180px]">
                  <div
                    className="fs-16 family_outfit_medium_500 lh-16 bg-[#874529] h-[47px] flex items-center justify-center text-white cursor-pointer w-full gap-[10px]"
                    onClick={() => {
                      setDrawerOpen(true);
                      setViewData({});
                    }}
                  >
                    <Image src={AddIcon} alt={'icon'} />
                    <div>Create</div>
                  </div>
                </div>
              )}
            </div>
          )}
          {leadLoader || loading ? (
            <Loader marginTop={userRole === 'enterprise-admin' ? '10vh' : ''} />
          ) : (
            <div className="mt-[30px]">
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Name
                  </p>
                </Col>
                <Col
                  lg={userRole === 'enterprise-admin' ? 1 : 2}
                  md={6}
                  sm={12}
                >
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Contact Info
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Identity
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Company Name
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Title/Role
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Practice Type
                  </p>
                </Col>
                {userRole === 'enterprise-admin' && (
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      Action
                    </p>
                  </Col>
                )}
              </Row>
              <Row className="bc-FFFFFF m-0 p-0">
                {leadList && leadList?.length > 0 ? (
                  leadList?.map((item, index) => (
                    <Row
                      className="m-0 p-0 flex items-center listAppointment"
                      key={index}
                    >
                      <Col
                        lg={2}
                        md={6}
                        sm={12}
                        className="cursor-pointer"
                        onClick={() => {
                          handleDetail(item);
                        }}
                      >
                        <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                          {item?.full_name}
                        </div>
                        <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                          {moment(item?.created_at).format('DD MMM YYYY')}
                        </div>
                      </Col>
                      <Col
                        lg={userRole === 'enterprise-admin' ? 1 : 2}
                        md={6}
                        sm={12}
                      >
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all">
                          {item?.admin_details?.full_name}
                        </div>
                        <div className="pt-04 flex items-center gap-[10px]">
                          {item?.email && (
                            <Tooltip title={item?.email} arrow>
                              <Image
                                src={mail}
                                alt="icon"
                                style={{ cursor: 'pointer' }}
                              />
                            </Tooltip>
                          )}
                          {item?.mobile_number && (
                            <Tooltip
                              title={item?.country_code + item?.mobile_number}
                              arrow
                            >
                              <Image
                                src={call}
                                alt="icon"
                                style={{ cursor: 'pointer' }}
                              />
                            </Tooltip>
                          )}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {`${item?.user_type?.name}`}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {`${item?.company_organization}`}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {`${item?.title_role}`}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {`${item?.practice_type?.name ? item?.practice_type?.name : 'NA'}`}
                        </div>
                      </Col>
                      {userRole === 'enterprise-admin' && (
                        <Col lg={1} md={6} sm={12}>
                          <MoreVertOutlinedIcon
                            aria-describedby={id}
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => handleAction(e, item)}
                          />
                        </Col>
                      )}
                    </Row>
                  ))
                ) : (
                  <div className="flex flex-col justify-center items-center py-[50px]">
                    <Image
                      src={EmptyScreen}
                      alt="icon"
                      width={'301px'}
                      height={'224px'}
                    />
                    <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                      Nothing here yet
                    </div>
                  </div>
                )}
              </Row>
            </div>
          )}
          {count > 1 && (
            <Col sm={12} className="flex justify-end mt-10 p-0">
              <ReusablePagination
                count={count}
                page={page}
                showFirstButton
                showLastButton
                onChange={(event, value) => handlePageChange(event, value)}
                borderColor="#00000"
                textColor="#00000"
                selectedBgColor="#EBEBE4"
                selectedTextColor="#00000"
                selectedBorderColor="#00000"
                ellipsisBorder="none"
                borderWidth="2px"
                borderStyle="dashed"
              />
            </Col>
          )}
          <CreateLead
            open={drawerOpen}
            onClose={handleDrawerClose}
            editData={viewData}
          />
          {/* download & delete modal */}
          <CommonModal
            padding={'24px'}
            width={'500px'}
            modalActive={isModalActive}
            innerContent={
              <div>
                {type === 'download' && (
                  <Row>
                    <Col xs={12}>
                      <div className="">
                        <p className="p-0 m-0 fs-20 fc-292D32 family_outfit_medium_500">
                          Choose a format to download your file.
                        </p>
                      </div>
                    </Col>
                    <Col xs={12} className="mt-3">
                      <RadioGroup
                        value={formData?.download || ''}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            ['download']: e.target.value,
                          }));
                        }}
                      >
                        {downloadData?.map((item) => (
                          <FormControlLabel
                            key={item.id}
                            value={item?.slug}
                            control={
                              <Radio
                                sx={{
                                  color: '#375241',
                                  '&.Mui-checked': { color: '#375241' },
                                }}
                              />
                            }
                            label={item.name}
                          />
                        ))}
                      </RadioGroup>
                    </Col>
                    <Col xs={12} md={12} className="mt-3 flex justify-end">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center justify-end p-0"
                      >
                        <ReusableButton
                          fullWidth={false}
                          variant="outlined"
                          color="#3C3C3C"
                          fontSize="14px"
                          fontWeight="500"
                          padding="12px 50px"
                          height="44px"
                          bgColor="transparent"
                          brColor="#EFE3D7"
                          fontFamily="outfit_medium"
                          onClick={() => setIsModalActive(false)}
                        >
                          Cancel
                        </ReusableButton>

                        <ReusableButton
                          fullWidth={false}
                          variant="contained"
                          color="#F5F5F5"
                          fontSize="14px"
                          fontWeight="500"
                          padding="12px 50px"
                          height="44px"
                          bgColor="#375241"
                          brColor="#375241"
                          fontFamily="outfit_medium"
                          onClick={() => {
                            !downloadLoader && downloadFile();
                          }}
                          loading={downloadLoader}
                        >
                          Download
                        </ReusableButton>
                      </Stack>
                    </Col>
                  </Row>
                )}
                {type === 'delete' && (
                  <Row>
                    <Col xs={12}>
                      <div className="">
                        <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                          Are you sure you want to delete?
                        </p>
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-3 flex justify-end">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center justify-end p-0"
                      >
                        <ReusableButton
                          fullWidth={false}
                          variant="outlined"
                          color="#3C3C3C"
                          fontSize="14px"
                          fontWeight="500"
                          padding="12px 50px"
                          height="44px"
                          bgColor="transparent"
                          brColor="#EFE3D7"
                          fontFamily="outfit_medium"
                          onClick={() => {
                            setIsModalActive(false);
                            handleClose();
                          }}
                        >
                          Cancel
                        </ReusableButton>

                        <ReusableButton
                          fullWidth={false}
                          variant="contained"
                          color="#F5F5F5"
                          fontSize="14px"
                          fontWeight="500"
                          padding="12px 50px"
                          height="44px"
                          bgColor="#375241"
                          brColor="#375241"
                          fontFamily="outfit_medium"
                          onClick={() => {
                            handleDelete();
                            handleClose();
                          }}
                          loading={leadDeleteLoader}
                        >
                          Delete
                        </ReusableButton>
                      </Stack>
                    </Col>
                  </Row>
                )}
              </div>
            }
          />
          {/* download & delete modal */}

          {/* edit and delete */}
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <Box>
              <Box
                onClick={() => {
                  handleLeadEdit();
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  px: 3,
                  py: 1,
                  cursor: 'pointer',
                  borderBottom: '1px solid #eee',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <EditIcon fontSize="small" />
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 400,
                    fontFamily: 'Outfit, sans-serif',
                  }}
                >
                  Edit
                </Typography>
                {leadDetailLoader && (
                  <CircularProgress color="inherit" size={'14px'} />
                )}
              </Box>
              <Box
                onClick={() => {
                  setIsModalActive(true);
                  setType('delete');
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  px: 3,
                  py: 1,
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <DeleteIcon fontSize="small" />
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 400,
                    fontFamily: 'Outfit, sans-serif',
                  }}
                >
                  Delete
                </Typography>
              </Box>
            </Box>
          </Popover>
          {/* edit and delete */}
        </Col>
      </Row>
    </div>
  );
};

export default LeadCapture;
